import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "SelectMVPModal.title",
    defaultMessage: "Select Match MVP",
  },
  description: {
    id: "SelectMVPModal.description",
    defaultMessage: "Choose the Most Valuable Player of this match",
  },
  confirm: {
    id: "SelectMVPModal.confirm",
    defaultMessage: "Confirm MVP",
  },
  cancel: {
    id: "SelectMVPModal.cancel",
    defaultMessage: "Cancel",
  },
});
